import { Textarea, Select } from "@/storybook-components";
import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
// import { QuestionFooter } from "../question-footer";
// import { QuestionTitle } from "../question-title";
import { DropdownQuestionProps } from "../types";

export const DropDownQuestion = (props: DropdownQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    questionLabel,
    questionLabelType,
    layoutProps,
    questionId,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    contentClassName,
    menuPlacement = "auto",
    placeholder,
    isDisabled,
    changeEventHandler,
    answerProps,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps,
    handleOtherChange,
    options,
    onMenuClose,
    onMenuOpen,
    otherAnswer,
    answerAriaLabel,
    size = "lg",
    optionSize = "lg",
    optionClassName,
    isClearable = true
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    questionLabel,
    questionLabelType,
    layoutProps,
    labelClassName,
    questionId,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  };
  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Select
          inputId={questionId}
          size={size}
          isClearable={isClearable}
          menuPlacement={menuPlacement}
          onChange={changeEventHandler}
          isDisabled={isDisabled}
          isSearchable={false}
          value={answer}
          classNamePrefix="ehq-dropdown"
          className={contentClassName}
          placeholder={placeholder}
          aria-label={answerAriaLabel}
          options={options}
          onMenuClose={onMenuClose}
          onMenuOpen={onMenuOpen}
          {...answerProps}
        />
        {options.map(
          (option: any) =>
            option.supportsTextAnswer &&
            answer?.id === option.id && (
              <Textarea
                mt={2}
                isRequired
                aria-label={option.name}
                id={`other${option.id}`}
                key={`other-${option.id}`}
                onChange={handleOtherChange}
                className={optionClassName}
                value={otherAnswer}
                size={optionSize}
                {...answerProps}
              />
            )
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
